// extracted by mini-css-extract-plugin
export default {"bigNumber":"V4lMPhtE2YeDCuORD5X4"};